export default __webpack_public_path__ + "static/orangeloop-intelligenza-artificiale-sviluppo-software-22040a5a2ba37f12d064fb32c25837dc.jpg";